import { Button, makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import { font } from 'app/theme'
import React from 'react'
import { View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { areDefaultFilters } from '../context'
import { Preset } from '../types'

interface SaveFilterViewProps {
  savedPresets: Preset[] | undefined
  onSaveFilter: (selectedPreset: Preset) => void
}

export function SaveFilterView({
  savedPresets,
  onSaveFilter,
}: SaveFilterViewProps) {
  const styles = useStyles()

  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.root}>
      <View style={styles.container}>
        <View>
          <Text style={styles.saveText}>{t('saveFilterText')}</Text>
        </View>
        <View style={styles.savedFiltersContainer}>
          <View style={styles.presetButtonsContainer}>
            {savedPresets && savedPresets.length > 0
              ? savedPresets.map((preset, index) => (
                  <Button
                    title={`${preset.id + 1}`}
                    onPress={() => onSaveFilter(preset)}
                    containerStyle={[
                      styles.presetButtonContainer,

                      styles.presetButton,
                    ]}
                    buttonStyle={styles.presetButton}
                    titleStyle={[
                      styles.presetButtonTitle,
                      areDefaultFilters(preset.filters)
                        ? {}
                        : styles.savedPresetButtonTitle,
                    ]}
                    key={String(index)}
                  />
                ))
              : null}
          </View>
        </View>
      </View>
    </SafeAreaView>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
  },
  container: {
    marginHorizontal: 0,
    paddingHorizontal: 0,
    flex: 1,
    backgroundColor: theme.colors?.grey6,
  },
  saveText: {
    margin: 10,
    fontWeight: 'bold',
    color: theme.colors?.grey1,
  },
  savedFiltersContainer: {
    marginTop: 10,
    marginHorizontal: 20,
  },
  presetButtonsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    flex: 1,
    maxWidth: 400,
    marginTop: 10,
  },
  presetButtonContainer: {
    flex: 1,
    justifyContent: 'center',
    margin: 10,
    borderRadius: 50,
    borderColor: theme.colors?.primary,
    borderWidth: 1,
    height: 100,
    maxWidth: 100,
  },
  presetButton: {
    backgroundColor: 'white',
  },
  presetButtonTitle: {
    color: theme.colors?.primary,
    fontWeight: 'normal',
    fontSize: 42,
  },
  savedPresetButtonTitle: {
    fontFamily: font.bold,
    fontWeight: 'bold',
  },
}))
